

export default {
  choose: 'Choose {n}'
};
